import { Component,Input,Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'upsc-custom-confirmation',
  templateUrl: './custom-confirmation.component.html',
  styles: []
})
export class CustomConfirmationComponent {

   @Input () CustomMessage;
    @Input () Id;
    @Output() notify: EventEmitter<string> = new EventEmitter<string>();
   
    constructor() {

    }

    onSuccess(val: string) {        
        this.notify.emit(val);
    }

}
